/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import CenteredSpinner from './CenteredSpinner';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import ScrollToTop from 'react-scroll-to-top';
import { useDispatch } from 'react-redux';
import { propertiesMap } from '../redux/action';
import { ReasonModal } from './ReasonModal';
import { PropertyCard } from './PropertyCard';
import Select from 'react-select';
import { ScrollContext } from "./ScrollContext";


export const PropertyRecentListings = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [comment, setComment] = useState('');
  const [propertyID, setPropertyID] = useState('');
  const [userID] = useState(localStorage.getItem('userId'));
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();


  const [regionId, setRegionId] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).regionId : 1;
  });

  const [days, setDays] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).days : 7;
  });
  
  const [propertyRef, setPropertyRef] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).propertyRef : null;
  });
  
  const [pageSize, setPageSize] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).pageSize : 20;
  });
  
  const [properties, setProperties] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).properties : '';
  });
  
  const [newFilter, setNewFilter] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).newFilter : true;
  });
  
  const [offMarketFilter, setOffMarketFilter] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).offMarketFilter : true;
  });
  
  const [bomFilter, setBomFilter] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).bomFilter : true;
  });
  
  const [priceFilter, setPriceFilter] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).priceFilter : true;
  });
  
  const [residentialFilter, setResidentialFilter] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    const staffSetting = JSON.parse(localStorage.getItem('staffMemberSettings')).worksOnResidential;
    return savedState ? JSON.parse(savedState).residentialFilter : staffSetting;
  });
  
  const [commercialFilter, setCommercialFilter] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    const staffSetting = JSON.parse(localStorage.getItem('staffMemberSettings')).worksOnCommercial;
    return savedState ? JSON.parse(savedState).commercialFilter : staffSetting;
  });
  
  const [salesFilter, setSalesFilter] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    const staffSetting = JSON.parse(localStorage.getItem('staffMemberSettings')).worksOnSales;
    return savedState ? JSON.parse(savedState).salesFilter : staffSetting;
  });
  
  const [lettingFilter, setLettingFilter] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    const staffSetting = JSON.parse(localStorage.getItem('staffMemberSettings')).worksOnLetting;
    return savedState ? JSON.parse(savedState).lettingFilter : staffSetting;
  });
  
  const [disabled, setDisabled] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).disabled : false;
  });
  
  const [reasonError, setReasonError] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).reasonError : '';
  });
  
  const [commentError, setCommentError] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).commentError : '';
  });
  
  const [selectedOption, setSelectedOption] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).selectedOption : null;
  });

  const [scrollPositionHere, setScrollPosition] = useState(() => {
    const savedState = sessionStorage.getItem('propertyRecentListingsState');
    return savedState ? JSON.parse(savedState).scrollPosition : 0;
  });


// Use the useContext hook to get the value from the context
  const { isBottom } = React.useContext(ScrollContext);
  const { scrollPosition } = React.useContext(ScrollContext);

  useEffect(() => {
    const saved = localStorage.getItem('properties');
    let details =
      location?.state === undefined
        ? JSON.parse(saved)
        : location?.state;
    setProperties(details);
    if (location?.state) {
      localStorage.setItem(
        'properties',
        JSON.stringify(location?.state),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state]);

  useEffect(() => {
    // Check if isBottom is true
    if (isBottom) {
      setPageSize(pageSize + 20);
    }
  }, [isBottom]);

  useEffect(() => {
    sessionStorage.setItem('propertyRecentListingsState', JSON.stringify({
      showModal,
      reason,
      description,
      data,
      loading,
      comment,
      propertyID,
      regionId,
      days,
      propertyRef,
      pageSize,
      properties,
      newFilter,
      offMarketFilter,
      bomFilter,
      priceFilter,
      residentialFilter,
      commercialFilter,
      salesFilter,
      lettingFilter,
      disabled,
      reasonError,
      commentError,
      selectedOption,
      scrollPosition
    }));
  }, [
    showModal,
    reason,
    description,
    data,
    loading,
    comment,
    propertyID,
    regionId,
    days,
    propertyRef,
    pageSize,
    properties,
    newFilter,
    offMarketFilter,
    bomFilter,
    priceFilter,
    residentialFilter,
    commercialFilter,
    salesFilter,
    lettingFilter,
    disabled,
    reasonError,
    commentError,
    selectedOption,
    scrollPosition
  ]);

  const handleReasonChange = (event) => {
    setReasonError(null);
    setReason(event.value);
    setDescription(event.label);
  };

  const { data: regionData } = useQuery(
    ['zoneData'],
    () => fetchRegions(),
    { refetchOnWindowFocus: false },
  );

  const fetchRegions = () => {
    const options = {
      method: 'GET',
      url: `/lookuptoken/GetGeoRegionTokens/`,
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return {
            value: element.id,
            label: element.text,
          };
        });
        setSelectedOption(options[0]);
        return options;
      })
      .catch((error) => {});
  };

  const fetchReason = () => {
    const options = {
      method: 'GET',
      url: `/propertyfavouritereason`,
    };

    return axios
      .request(options)
      .then((response) => {
        let options = response.data.map((element) => {
          return {
            value: element.id,
            label: element.description,
          };
        });
        return options;
      })
      .catch((error) => {});
  };

  const reasonModal = (e, id, propertyRef, localReason = null) => {
    if (localReason) {
      setReason(localReason);
    }
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
    setPropertyID(id);
    setPropertyRef(propertyRef);
  };

  const handleComment = (e) => {
    setCommentError(null);
    setComment(e.target.value);
  };

  const addFavourite = async (e) => {
    setDisabled(true);
    if (!reason) {
      setReasonError("Reason input can't be empty");
      setDisabled(false);
      return;
    }
    if (!comment) {
      setCommentError("Comment input can't be empty");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let d = new Date();
    let isoDate = d.toISOString();

    const config = {
      method: 'POST',
      url: '/propertyfavourite',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        sys_UserId: userID,
        dateRegistered: isoDate,
        propertyFavouriteReasonId: reason,
        comments: comment,
      }),
    };

    try {
      const data = await axios(config);
      if (data.status == 201) {
        setReason('');
        setComment('');
        setDisabled(false);
        toast.success(
          `Property: ${propertyRef} has been added to ${description}`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        setShowModal(false);
      }
    } catch (err) {
      if (
        err.response.status === 400 &&
        err.response.data.message ===
          'bizrule_propertyFavourite_favouriteReasonAlreadyExists'
      )
        toast.error(
          `Sorry,Property: ${propertyRef} wasn't added, It has been already added`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
      if (err.response.status === 500)
        toast.error(
          `Sorry,Server error, Property: ${propertyRef} wasn't added, try again later`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
      setComment('');
      setDisabled(false);
    }
  };

  const handleDaysFilterChange = (e) => {
    setDays(e.target.value);
  };

  const handleNewFilterChange = () => {
    setNewFilter(!newFilter);
    setLoading(true);
  };

  const handleOffMarketFilterChange = () => {
    setOffMarketFilter(!offMarketFilter);
    setLoading(true);
  };

  const handleBomFilterChange = () => {
    setBomFilter(!bomFilter);
    setLoading(true);
  };

  const handlePriceFilterChange = () => {
    setPriceFilter(!priceFilter);
    setLoading(true);
  };

  const handleResidentialFilterChange = () => {
    setResidentialFilter(!residentialFilter);
    setLoading(true);
  };

  const handleCommecialFilterChange = () => {
    setCommercialFilter(!commercialFilter);
    setLoading(true);
  };

  const handleSalesFilterChange = () => {
    setSalesFilter(!salesFilter);
    setLoading(true);
  };

  const handleLettingFilterChange = () => {
    setLettingFilter(!lettingFilter);
    setLoading(true);
  };

  const handleZoneChange = (option) => {
    setSelectedOption(option);
    setRegionId(option.value);
    setLoading(true);
  }

  const handleFilters = () => {
    let data = {
      days: days,
      geoRegionId: regionId,
      isNew: newFilter,
      isBOM: bomFilter,
      isOffMarket: offMarketFilter,
      isPriceChange: priceFilter,
      isResidential: residentialFilter,
      isCommercial: commercialFilter,
      isSales: salesFilter,
      isLetting: lettingFilter,
      page: 1,
      pageSize: pageSize
    };


    const options = {
      method: 'POST',
      url: '/PropertyChange/GetChangesInPropertiesList',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    return axios
      .request(options)
      .then((response) => {
        dispatch(propertiesMap(response.data.data));
        setData(response.data.data);
        setLoading(false);

        //Scroll to previous result
        if (scrollPositionHere > 0)
          window.scrollTo(0, scrollPositionHere);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  useEffect(() => {
    //A filter has changed, reset page size
    setPageSize(20);
    const fetchData = () => {            
      handleFilters();
    };
    fetchData();
  }, [regionId, days, newFilter, offMarketFilter, bomFilter, priceFilter, residentialFilter, commercialFilter, salesFilter, lettingFilter]);

  useEffect(() => {
    setScrollPosition(0);
    const fetchData = () => {            
      handleFilters();
    };
    fetchData();
  }, [pageSize]);

  const { data: reasonData } = useQuery(['Reason'], fetchReason);

  if (loading) {
    return <CenteredSpinner />;
  }

  const totalResults = data?.length ?? 0;

  return (
    <div className="container pt-3 pb-4" onScroll={() => setScrollPosition(scrollPosition)}>
      <ScrollToTop smooth color="#6f00ff" />
      <div className="card shadow-sm border-0 overflow-hidden property-list-card">
        <div className="property-list-hero d-flex align-items-center px-4 py-3">
          <div className="property-list-hero-icon d-flex align-items-center justify-content-center">
            <i className="fas fa-clock" aria-hidden="true"></i>
          </div>
          <div className="ml-3">
            <p className="mb-1 text-uppercase text-white-50 small">Recent Listings</p>
            <h4 className="mb-0 text-white">Latest property changes.</h4>
          </div>
          <button
            type="button"
            className="btn btn-light btn-sm ml-auto property-list-back"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Back
          </button>
        </div>

        <div className="p-4 property-form-page">
          <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between">
            <div>
              <p className="mb-1 text-muted small">Property changes</p>
              <h5 className="mb-0">Filter by region and change type.</h5>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 col-lg-6 mb-3">
              <div className="property-details-card">
                <label className="property-details-label">Region</label>
                <Select
                  classNamePrefix="react-select"
                  onChange={handleZoneChange}
                  value={selectedOption}
                  isSearchable={false}
                  options={regionData}
                />
              </div>
            </div>
            <div className="col-12 col-lg-6 mb-3">
              <div className="property-details-card">
                <label className="property-details-label">Last (days)</label>
                <div className="d-flex align-items-center">
                  <input
                    className="form-control d-block"
                    type="text"
                    name="days"
                    onBlur={handleDaysFilterChange}
                    onChange={handleDaysFilterChange}
                    value={days}
                  />
                  <span className="ml-2 text-muted small">days</span>
                </div>
              </div>
            </div>
          </div>

          <div className="property-details-card mb-4">
            <label className="property-details-label">Filters</label>
            <div className="property-pill-grid">
              <button
                type="button"
                className={`property-pill ${newFilter ? 'property-pill--active' : ''}`}
                onClick={handleNewFilterChange}
                aria-pressed={newFilter}
              >
                New
              </button>
              <button
                type="button"
                className={`property-pill ${bomFilter ? 'property-pill--active' : ''}`}
                onClick={handleBomFilterChange}
                aria-pressed={bomFilter}
              >
                BOM
              </button>
              <button
                type="button"
                className={`property-pill ${offMarketFilter ? 'property-pill--active' : ''}`}
                onClick={handleOffMarketFilterChange}
                aria-pressed={offMarketFilter}
              >
                Off Market
              </button>
              <button
                type="button"
                className={`property-pill ${priceFilter ? 'property-pill--active' : ''}`}
                onClick={handlePriceFilterChange}
                aria-pressed={priceFilter}
              >
                Price Chgs
              </button>
              <button
                type="button"
                className={`property-pill ${residentialFilter ? 'property-pill--active' : ''}`}
                onClick={handleResidentialFilterChange}
                aria-pressed={residentialFilter}
              >
                Residential
              </button>
              <button
                type="button"
                className={`property-pill ${commercialFilter ? 'property-pill--active' : ''}`}
                onClick={handleCommecialFilterChange}
                aria-pressed={commercialFilter}
              >
                Commercial
              </button>
              <button
                type="button"
                className={`property-pill ${salesFilter ? 'property-pill--active' : ''}`}
                onClick={handleSalesFilterChange}
                aria-pressed={salesFilter}
              >
                Sales
              </button>
              <button
                type="button"
                className={`property-pill ${lettingFilter ? 'property-pill--active' : ''}`}
                onClick={handleLettingFilterChange}
                aria-pressed={lettingFilter}
              >
                Letting
              </button>
            </div>
          </div>

          {totalResults < 1 ? (
            <h5 className="text-center text-muted">No results, adjust filters.</h5>
          ) : null}

          <div className="row">
            {data &&
              React.Children.toArray(
                data?.map((property, index) => (
                  <PropertyCard 
                    property={property}
                    index={index}
                    location={location}
                    showHotBtn={true}
                    showFavouriteBtn={true}
                    reasonModal={reasonModal}
                    showRemarks={true}
                  />
                )),
              )}
          </div>
          <ReasonModal
            showModal={showModal}
            reason={reason}
            setReason={setReason}
            setReasonError={setReasonError}
            setCommentError={setCommentError}
            setShowModal={setShowModal}
            reasonError={reasonError}
            handleReasonChange={handleReasonChange}
            reasonData={reasonData}
            comment={comment}
            handleComment={handleComment}
            commentError={commentError}
            disabled={disabled}
            addFavourite={addFavourite}
          />
        </div>
      </div>
    </div>
  );
};
